import { environment } from "../config/environment";
import {
  getFromBackendAPI,
  uploadFileToBackendAPI,
  deleteFromBackendAPI,
  downloadFileFromBackendAPI,
} from "./api.service";

export interface DiscussionAttachmentDto {
  id: number;
  discussionId: number;
  fileName: string;
  contentType: string;
  fileSize: number;
  uploadedByEmail?: string;
  uploadedByName?: string;
  uploadedAt: string;
}

const base = (discussionId: number) =>
  `${environment.api.baseUrl}${environment.api.endpoints.discussions}/${discussionId}/attachments`;

export async function getDiscussionAttachments(discussionId: number): Promise<DiscussionAttachmentDto[]> {
  return await getFromBackendAPI<DiscussionAttachmentDto[]>(base(discussionId));
}

export async function uploadDiscussionAttachment(
  discussionId: number,
  file: File
): Promise<DiscussionAttachmentDto> {
  const formData = new FormData();
  formData.append("file", file, file.name);
  return await uploadFileToBackendAPI<DiscussionAttachmentDto>(base(discussionId), formData);
}

export async function deleteDiscussionAttachment(discussionId: number, attachmentId: number): Promise<void> {
  await deleteFromBackendAPI(`${base(discussionId)}/${attachmentId}`);
}

/**
 * Fetches the attachment bytes as a Blob. The URL you pass into
 * `<img src>` / `<a href>` should come from `URL.createObjectURL(blob)` — the
 * download endpoint is behind auth so a bare URL won't work.
 */
export async function downloadDiscussionAttachment(discussionId: number, attachmentId: number): Promise<Blob> {
  return await downloadFileFromBackendAPI(`${base(discussionId)}/${attachmentId}/download`);
}
